import styled from 'styled-components';
const CollapseContainerStyle = styled.div `
	&.clickable-all {
		#collapse-item {
			cursor: pointer;
		}
	}

	&.clickable-title {
		#collapse-title {
			cursor: pointer;
		}
	}
`;
export default CollapseContainerStyle;
//# sourceMappingURL=style.js.map